import React from 'react';
import StatusbarConstants from '../../../../../constants/statusbar_constants';
import { DimensionsMissing } from './dimensions_missing';
import { AllMissing } from './all_missing';
import { WithIndex } from './with_index';

function getSizeValueComponent(status, filters, displayDimensions = '') {
    switch (status) {
        case StatusbarConstants.TYRE_INDEX_AND_POSTCODE_MISSING:
        case StatusbarConstants.SPEED_INDEX_MISSING:
        case StatusbarConstants.LOAD_INDEX_MISSING:
        case StatusbarConstants.TYRE_INDEX_MISSING:
            return <WithIndex filters={filters} highlight="blue" displayDimensions={displayDimensions} />;

        case StatusbarConstants.POSTCODE_MISSING:
        case StatusbarConstants.NONE_MISSING:
            return <WithIndex filters={filters} displayDimensions={displayDimensions} />;

        case StatusbarConstants.ALL_MISSING:
            return <AllMissing highlight="red" />;

        case StatusbarConstants.DIMENSIONS_MISSING:
            /* falls through */
        default:
            return <DimensionsMissing filters={filters} highlight="yellow" />;
    }
}

export { getSizeValueComponent };